import { useConditional } from "../../core/hooks/useConditional";
import { first } from "../../core/utils/array";
import { FormInline } from "../../data-entry/FormModal";
import { GenericCol } from "../../layout/TableCells";
import { Company, entity } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { parseTrackedItems } from "./parseTrackedItem";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { Addresses } from "./Address";
import { Tab, TabContainer } from "../../core/ui/Tab";
import { CompanyOfficers } from "./CompanyOfficer";
import { CompanyShareholders } from "./CompanyShareholder";
import { RelationshipsTabContent } from "./RelationshipsTabContent";


export function CompanyEdit(props: {
	entity: entity,
}) {

	const company = props.entity.data as Company;

	const names = parseTrackedItems(company.names);
	const name = first(names.active);
	if (!company.names) company.names = [];

	if (!company.regOffs) company.regOffs = [];
	if (!company.ppobs) company.ppobs = [];
	if (!company.shareHolders) company.shareHolders = [];
	if (!company.officers) company.officers = [];


	const edit = useConditional(() => {
		return (
			<EditTrackedItem
				title="Edit Company Name"

				arr={company.names}
				initialValues={name}

				canHaveOnlyOneActive={true}

				form="entity-company-name-edit"
				formOptions={{
					showEffective: true,
				}}

				onCancel={edit.close}
				onClose={edit.close}
			/>
		)
	});

	const history = useConditional(() => {
		return (
			<HistoryModal
				title="Name History"
				onClose={history.close}
				items={company.names}
				cols={[
					GenericCol("Name", "name"),
				]}
			/>
		);
	})	

	return (
		<TabContainer displayStyle="border-indent">
			<Tab title="Details">
				<div className="flex horiz align-start gap-10 margin-bottom-10 ">
					<TrackedItemDisplay
						title="Name"
						item={name}
						edit={edit}
						history={history}
						className="bold"
					>
						{
							formatData(
								name ? 
								{
									lines: [ { parts: [ name.name ]} ]
								}
								: undefined
							)
						}
					</TrackedItemDisplay>
					<FormInline
						form="entity-company-edit"
						obj={company}
					/>
				</div>
			</Tab>

			<Tab title="Addresses">
				<div className="flex horiz align-start gap-10 space-evenly">
					<Addresses
						addressType="registered-office"
						addresses={company.regOffs}
					/>				
					<Addresses
						addressType="ppob"
						addresses={company.ppobs}
					/>				
				</div>
			</Tab>

			<Tab title="Officers">
				<CompanyOfficers officers={company.officers} />
			</Tab>
			<Tab title="Shareholders">
				<CompanyShareholders shareholders={company.shareHolders} />
			</Tab>
			<Tab title="Relationships">
				<RelationshipsTabContent entity={props.entity} />
			</Tab>
			<Tab title="Documents">

			</Tab>
		</TabContainer>
	);
}